import { UserRole } from '@depanneo/types'
import { requiredRoles } from '@/shared/utils/require-roles'
import { createFileRoute } from '@tanstack/react-router'
import SitesImportPage from '@/pages/sites/import'

/**
 * The permanent CSV import surface (#1546) — reachable from Sites once
 * `onboardingCompletedAt` is stamped, which is exactly when the wizard's copy
 * stops being.
 *
 * Roles mirror what the API already enforces: `SitesImportController` requires the
 * `Create/Site` ability, and `@depanneo/abilities` grants `Manage Site` to ADMIN and
 * FACILITY_MANAGER. `SUPER_ADMIN` bypasses `requiredRoles` and holds `Manage all`,
 * which is what makes this ONE surface for both audiences. VIEWER is deliberately
 * absent — it can read the sites list but not create.
 */
export const Route = createFileRoute('/_authenticated/org/$orgId/sites/import')(
  {
    beforeLoad: () => {
      requiredRoles([UserRole.ADMIN, UserRole.FACILITY_MANAGER])
    },
    component: SitesImportPage,
  }
)
